var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',_vm._g(_vm._b({staticClass:"has-text-centered",attrs:{"inline":"","day-names":[
        _vm.$t("dates.days_short.sunday"),
        _vm.$t("dates.days_short.monday"),
        _vm.$t("dates.days_short.tuesday"),
        _vm.$t("dates.days_short.wednesday"),
        _vm.$t("dates.days_short.thursday"),
        _vm.$t("dates.days_short.friday"),
        _vm.$t("dates.days_short.saturday") ],"month-names":[
        _vm.$t("dates.months.january"),
        _vm.$t("dates.months.february"),
        _vm.$t("dates.months.march"),
        _vm.$t("dates.months.april"),
        _vm.$t("dates.months.may"),
        _vm.$t("dates.months.june"),
        _vm.$t("dates.months.july"),
        _vm.$t("dates.months.august"),
        _vm.$t("dates.months.september"),
        _vm.$t("dates.months.october"),
        _vm.$t("dates.months.november"),
        _vm.$t("dates.months.december") ],"unselectable-days-of-week":_vm.enableSunday ? [] : [0],"first-day-of-week":1,"academic-year-start":_vm.academicYearStart},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'datepicker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb412b0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Calendar.vue
// module id = Oxl3
// module chunks = 1